
import { BlakeData } from "./BlakeData";
import { BookRecord, EditionRecord, PrintRecord, SwatchObject } from "./Types";

/**
 * For an array that should have only one element, return the 
 * element, or throw an error. Helpful for unpacking results 
 * when we search for a specific index and expect it to be unique
 */
function unpackItemArray<T>(arr: Array<T>): T {
    if (arr.length > 1) {
        throw new Error("Nothing found");
    }
    if (arr.length > 1) {
        throw new Error("Multiple items found, expected only one");
    }
    if (arr.length === 1) {
        return arr[0];
    }

    throw new Error("Error looking up book with id")

}

async function getFullPrintObjects(printIDs: Array<string>) {

    let sortIndexCache: { [idx: string]: number } = {};
    const getSortIndex = (p: PrintRecord) => {
        if (!sortIndexCache.hasOwnProperty(p.id)) {
            sortIndexCache[p.id] = printIDs.indexOf(p.id);
        }
        return sortIndexCache[p.id]
    }

    // const startTime = new Date();

    return BlakeData.getInstance().getDexie().prints.where("id").anyOf(printIDs).toArray()
        .then(arr => {
            // const endTime = new Date();
            // console.log("timing getFullPrintObjects() " + printIDs.length, endTime.getTime() - startTime.getTime());
            return arr;
        })
        .then(arr => arr.sort((a: PrintRecord, b: PrintRecord) => {
            // if (printIDs.indexOf(a.id) < printIDs.indexOf(b.id)) { return -1 }
            if (getSortIndex(a) < getSortIndex(b)) { return -1 }


            return 1;
        }))
    // ret = ret.sort((a:PrintRecord, b:PrintRecord)=>{
    //     if (printIDs.indexOf(a.id) < printIDs.indexOf(b.id)){ return -1}
    //     return 1;
    // })

    // const retIDs = ret.map(p=>p.id) 
    // if (retIDs.join("") !== printIDs.join("")){
    //     console.log("getFullPrintObjects out of sequence: ", printIDs, retIDs)
    // }

    // return ret;
}

/**
 * A façade for the Blake data model that will allow the backend 
 * implementation to change without affecting the client (front-end app).
 * This should represent all a client needs to interface with, in addition
 * to the Types.
 */
export const API = {

    /**
     * Get a book by ID
     * @param id the book's ID
     */
    async getBook(id: string): Promise<BookRecord> {

        // const startTime = new Date();

        return BlakeData.getInstance().getDexie().books.where("id").equals(id).toArray()
            // .then(args => { console.log(`"timing getBook(${id})"`, new Date().getTime() - startTime.getTime()); return args })
            .then(arr => unpackItemArray(arr));
        // -- 
        // const arr: Array<BookRecord> = await BlakeData.getInstance().getDexie().books.where("id").equals(id).toArray();
        // const endTime = new Date();
        // // console.log("timing getBook(" + id + "):", endTime.getTime() - startTime.getTime())
        // return unpackItemArray(arr)

    },
    getFullPrintObjects,
    /**
    * Get an edition with a given ID, then pass it to a callback
    * @param id the edition's ID
    */
    async getEdition(id: string) {

        // const startTime = new Date();

        return BlakeData.getInstance().getDexie().editions.where("id").equals(id).toArray()
            // .then(args => { console.log("timing getEdition()", new Date().getTime() - startTime.getTime()); return args })
            .then(arr => unpackItemArray(arr));

        // // -- 
        // const arr: Array<EditionRecord> = await BlakeData.getInstance().getDexie().editions.where("id").equals(id).toArray();
        // // console.log("timing getEdition(" + id + "):", new Date().getTime() - startTime.getTime())

        // return unpackItemArray(arr);
    },

    /**
    * Get prints in an edition, in order. For use in Edition View
    * @param edition EditionRecord
    */
    async getEditionPrints(edition: EditionRecord): Promise<Array<PrintRecord>> {

        // const startTime = new Date();

        // put in the order that we asked for them
        const printArray = edition.prints.map(p => p.id);
        const getIndexInProps = (p: PrintRecord) => {
            return printArray.indexOf(p.id);
        };

        let groupIDs: { [key: string]: string } = {};

        let validPrintIDs = edition.prints.map((p: PrintRecord) => {
            groupIDs[p.id] = p.groupID || "INVALID"
            return `${p.id}`
            /* Note: ensuring the return value is a string avoids a crash
             * but does not ensure correct behavior. This can screw up
             * if the schema changes and we're not finding the "groupID"
             * field in the PrintRecord items. Shouldn't be a problem 
             * going forward as long as DB versions are iterated along with
             * release versions.       
             */

        });

        // let prints: Array<PrintRecord> = [];

        ///

        return getFullPrintObjects(validPrintIDs)
            .then(prints => {
                // console.log("timing getEditionPrints A(" + edition.id + "):", new Date().getTime() - startTime.getTime())
                return prints;
            })
            .then(prints => {
                return prints.sort((a: PrintRecord, b: PrintRecord) => {
                    if (getIndexInProps(a) < getIndexInProps(b)) { return -1; }
                    return 1;
                })
                    .map((p: PrintRecord) => {
                        return {
                            ...p,
                            groupID: groupIDs[p.id]
                        }
                    })
            })

        // //---

        // try {
        //     // prints = await BlakeData.getInstance().getDexie().prints.where("id").anyOf(validPrintIDs).toArray()
        //     prints = await getFullPrintObjects(validPrintIDs);
        // } catch (e) {
        //     console.log("Caught exception ", e)

        //     // console.log("timing getEditionPrints 1(" + edition.id + "):", new Date().getTime() - startTime.getTime())

        //     return prints;
        // }

        // const sortedPrints = prints
        //     .sort((a: PrintRecord, b: PrintRecord) => {
        //         if (getIndexInProps(a) < getIndexInProps(b)) { return -1; }
        //         return 1;
        //     })
        //     .map((p: PrintRecord) => {
        //         return {
        //             ...p,
        //             groupID: groupIDs[p.id]
        //         }
        //     })

        // // console.log("timing getEditionPrints 2(" + edition.id + "):", new Date().getTime() - startTime.getTime())

        // return sortedPrints;
    },

    /**
     * Get prints by group id
     */
    async getPrintsByGroupID(groupID: string): Promise<Array<PrintRecord>> {


        // return BlakeData.getInstance().getDexie().prints.where("groupID").equals(groupID).toArray();


        // // I'm ont sure why this is query is so slow in safari
        // // so I'm short-circuiting it with session storage for now
        // const sessionItem = sessionStorage.getItem(`yaledh-blake-group-${groupID}`);
        // if (sessionItem){
        //     const parsed = JSON.parse(sessionItem);
        //     if ("prints" in parsed){
        //         return parsed.prints
        //     }

        // }   

        // It should be faster to use a separatre 
        const dx = BlakeData.getInstance().getDexie();
        const groups = dx.groups;

        // const startTime = new Date();

        return groups.get(groupID)
            // .then(args => { console.log("timing getPrintsByGroupID()", new Date().getTime() - startTime.getTime()); return args })
            .then(ret => {
                if (ret) { return ret.prints };
                return [];
            })

        // // --
        // const ret = await groups.get(groupID);

        // return new Promise(function (resolve) {
        //     if (!ret) { resolve([]) }
        //     else {
        //         resolve(ret.prints)
        //     }
        // })


    },

    /**
     * Get an of SwatchObjects for a group of prints. Necessary for
     * constructing a Micropalette. Done in a batch to prevent chattiness
     * @param prints Prints to get swatches for
     */
    makeSwatchArray(prints: Array<PrintRecord>): SwatchObject[][] {
        return prints.map((p) => {

            if (!p.swatches) {
                console.warn("Swatches undefined!"); return []
            }
            const swatches = p.swatches || [];
            return swatches.map(s => {
                return {
                    percent: s[0],
                    color: s[1]
                }
            })
        });
    },

    getThumbnailURL(print: PrintRecord) {
        return `${process.env.PUBLIC_URL}/img/thumbs/thumb-${print.id}.300.jpg`
    },
    getQuantizedImageURL(print: PrintRecord) {
        // return `${process.env.PUBLIC_URL}/img/quantized/quantized-${print.id}.png`

        // 
        // example: http://blake-micropalettes.s3-website.us-east-2.amazonaws.com/quantized-vda.h.p5.png
        return `http://blake-micropalettes.s3-website.us-east-2.amazonaws.com/quantized-${print.id}.png`
    },


    /**
     * Get a URL for a 100 DPI image of a specific print
     * @param print PrintRecord
     */
    getImageURL100(print: PrintRecord) {
        return `${process.env.PUBLIC_URL}/img/${print.id}.100.jpg`
    },

    /**
     * Connect and initialize the API. Returns true on success, else false
     */
    connect(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            BlakeData.getInstanceWithCallback((db?: BlakeData) => {
                if (db) {
                    resolve(true);
                } else {
                    reject(false);
                }
            });
        });
    },

    /**
     * Get all editions, returns a promise
     */
    getAllEditions() {
        // const startTime = new Date();
        const ret = BlakeData.getInstance().getDexie().editions.toArray();
        // console.log("timing getAllEditions() ", new Date().getTime() - startTime.getTime())

        return ret;
    },

    /**
     * Get all books, returns a promise
     */
    getAllBooks() {
        return BlakeData.getInstance().getDexie().books.toArray();
    },

    /**
     * Get editions in a specific year, returns a promise
     * @param year 
     */
    getEditionsByYear(year: number) {

        return BlakeData.getInstance().getDexie().editions.where("year").equals(year).toArray()

    },

    /**
     * Get editions by book id, returns a promise.
     * @param bookID 
     */
    getEditionsByBookID(bookID: string) {

        return BlakeData.getInstance().getDexie().editions
            .where("bookID")
            .equalsIgnoreCase(bookID)
            .toArray();
    },
    /**
     * TODO - getEditionsGroupedByBook
     */
    getEditionsByBookGroup() {


    },
    /**
     * TODO - getEditionsGroupedByYear
     */
    getEditionsByYearGroup() {

    }

}